export default __webpack_public_path__ + "static/Slashdot-94ff78394bf8fd316649fbd463ff42e9.png";